export default __webpack_public_path__ + "static/media/gallery_07.4d64435a.jpg";